<template>
    <button :type="type" class="btn" :class="[color, size]">
        <i class="bi" :class="icon"></i>
        {{ text }}
        <slot/>
    </button>
</template>

<script>
export default {
    name: 'ButtonExec',
    props: {
        text: {
            type: String,
            default: '検索',
        },
        icon: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
        color: {
            type: String,
            default: 'btn-outline-secondary'
        },
        size: {
            type: String,
            default: '',
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
